export const gitCommit = '96d6ee59'
